// import React, {Component} from "react";
import { Tab, TabPanel, Tabs, TabList } from "react-web-tabs";
// import ReactDOM from "react-dom";
import "react-web-tabs/dist/react-web-tabs.css";
import config from 'react-global-configuration';
import {Link} from "react-router-dom";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import MappedMerchantData from 'components/MasterData/MappedData';
import UnmappedMerchantData from 'components/MasterData/UnMappedData';
import LinkedData from 'components/MasterData/LinkedData';
import MappedBrandData from 'components/MasterData/BrandMappedData';
import UnmappedBrandData from 'components/MasterData/BrandUnmappedData';
//import RefinementCriteria from "../components/MasterData/RefinementCriteria";
// import "./styles.css";
import MasterData from "brandemi/MasterData";
import BrandUnmappedData from "../components/MasterData/BrandUnmappedData";
import BrandMappedData from "../components/MasterData/BrandMappedData";

import React, {Component, useState} from 'react';
import axios from "axios";
import $ from 'jquery';
import {Button, Collapse, Input, Label, Modal, ModalBody, ModalFooter, Card, CardBody, CardText} from 'reactstrap';
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Select from 'react-select';
import Switch from 'react-switch';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
import jwt_decode from "jwt-decode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SimpleReactValidator from 'simple-react-validator';
import AsyncPaginate, {reduceGroupedOptions} from 'react-select-async-paginate';
import moment from 'moment';
import loadOptions from './loadOptions';
import CommonNavbar, {navbar} from "./commonNavbar";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import {List} from "react-virtualized";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

const defaultAdditional = {
    page: 1
};

const loadPageOptions = async (q, prevOptions, { page }) => {
    const { options, hasMore } = await loadOptions(q, page);
    return {
        options,
        hasMore,
        additional: {
            page: page + 1
        }
    };
};


class NewCreatePromotion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activer: {
                '0': false,
                '1': false,
                '2': false,
                '3': false,
                '4': false,
                '5': false,
                '6': false,
                '7': false,
                '8': false,
                '9': false,
                '10': false,
                '11': false
            },
            isEMI: {
                '0': false,
                '1': false,
                '2': false,
                '3': false,
                '4': false,
                '5': false,
                '6': false,
                '7': false,
                '8': false,
                '9': false,
                '10': false,
                '11': false
            },
            isUpfront: {
                '0': false,
                '1': false,
                '2': false,
                '3': false,
                '4': false,
                '5': false,
                '6': false,
                '7': false,
                '8': false,
                '9': false,
                '10': false,
                '11': false
            },
            zeroCost: {
                '0': false,
                '1': false,
                '2': false,
                '3': false,
                '4': false,
                '5': false,
                '6': false,
                '7': false,
                '8': false,
                '9': false,
                '10': false,
                '11': false
            },
            mapField: false,
            bank_name_list: ["AMEX BANK", "AXIS BANK", "CITIBANK", "HDFC Bank", "HSBC Bank", "ICICI Bank", "INDUSIND BANK", "KOTAK BANK", "RBL BANK", "SBI CARD", "STANDARD CHARTERED BANK", "YES BANK"],
            tenure_list: {
                '0': true,
                '1': true,
                '2': true,
                '3': true
            },
            bankOptions: [
                { name: 'AMEX', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Axis', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Citi', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'HDFC', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'HSBC', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'ICICI', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'IndusInd', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Kotak', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'RBL', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'SBI', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'SCB', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'YES', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true}
            ],
            bankOptions1: [
                { name: 'AMEX', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Axis', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Citi', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'HDFC', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'HSBC', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'ICICI', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'IndusInd', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Kotak', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'RBL', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'SBI', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'SCB', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'YES', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true}
            ],
            brandSubventionOptions: [
                { value: 'Percent', label: 'Percent' },
                { value: 'Cashback', label: 'Flat Cashback' }
            ],
            bankSubventionOptions: [
                { value: 'NA', label: 'NA'  },
                { value: 'Percent', label: 'Percent' },
                { value: 'Cashback', label: 'Flat Cashback' }
            ],
            bankOptionsValuer: [
                {name: "AMEX BANK", value: 0},
                {name: "AXIS BANK", value: 1},
                {name: "CITIBANK", value: 2},
                {name: "HDFC Bank", value: 3},
                {name: "HSBC Bank", value: 4},
                {name: "ICICI Bank", value: 5},
                {name: "INDUSIND BANK", value: 6},
                {name: "KOTAK BANK", value: 7},
                {name: "RBL BANK", value: 8},
                {name: "SBI CARD", value: 9},
                {name: "STANDARD CHARTERED BANK", value: 10},
                {name: "YES BANK", value: 11},
            ],
            merchantSubventionOptions: [
                { value: 'All_Level', label: 'Applicable Everywhere'},
                { value: 'State_Level', label: 'State Level'},
                { value: 'City_Level', label: 'City Level'},
                { value: 'Merchant_Level', label: 'Merchant Level'},
                { value: 'Chain_Level', label: 'Chain Level' },
                { value: 'Store_Level', label: 'Store Level' },
            ],
            maxTxnAmount: 10000,
            selectedBrandSubvention: 'Percent',
            selectedBankSubvention: 'NA',
            selectedMerchantSubvention: 'All_Level',
            selectedState: [],
            selectedCity: [],
            merchant_disabler: true,
            //brand_subvention_list: ['Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent'],
            //bank_subvention_list: ['NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA'],
            brand_subvention_list:{
                '0': 'Percent',
                '1': 'Percent',
                '2': 'Percent',
                '3': 'Percent',
                '4': 'Percent',
                '5': 'Percent',
                '6': 'Percent',
                '7': 'Percent',
                '8': 'Percent',
                '9': 'Percent',
                '10': 'Percent',
                '11': 'Percent'
            },
            bank_subvention_list: {
                '0': 'NA',
                '1': 'NA',
                '2': 'NA',
                '3': 'NA',
                '4': 'NA',
                '5': 'NA',
                '6': 'NA',
                '7': 'NA',
                '8': 'NA',
                '9': 'NA',
                '10': 'NA',
                '11': 'NA'
            },
            brand_subvention_value: {
                '0': '10',
                '1': '10',
                '2': '10',
                '3': '10',
                '4': '10',
                '5': '10',
                '6': '10',
                '7': '10',
                '8': '10',
                '9': '10',
                '10': '10',
                '11': '10'
            },
            bank_subvention_value: {
                '0': '0',
                '1': '0',
                '2': '0',
                '3': '0',
                '4': '0',
                '5': '0',
                '6': '0',
                '7': '0',
                '8': '0',
                '9': '0',
                '10': '0',
                '11': '0'
            },
            maximum_cashback: {
                '0': '1000',
                '1': '1000',
                '2': '1000',
                '3': '1000',
                '4': '1000',
                '5': '1000',
                '6': '1000',
                '7': '1000',
                '8': '1000',
                '9': '1000',
                '10': '1000',
                '11': '1000'
            },
            disabler_list: [true, true, true, true, true, true, true, true, true, true, true, true],
            mapField2: false,
            startDate: moment(new Date()).format('YYYY-MM-DD'),
            endDate: moment(new Date()).format('YYYY-MM-DD'),
            sku_showModel: false,
            sku_list: [],
            raw_display_data: [],
            state_display_data: [],
            city_display_data: [],
            merchant_display_data: [],
            chain_display_data: [],
            store_display_data: [],
            state_data: [
                {value: "NA", label: "NA"}
            ],
            city_data: [
                {value: "NA", label: "NA"}
            ],
            state_loaded: false,
            city_loaded: false,
            sku_monitor: 0,
            scheme_monitor_incr: 0,
            selectedMerchValues: [],
            selectedRefineSubvention: [],
            slicedMerchValues: [],
            the_bank_list: {},
            bank_name_list1: {},
            refineSearch: false,
            state_ida: '',
            city_ida: '',
            merchant_ida: '',
            chain_ida: '',
            refinerMerch: [false, false, false, false, false],
            valuera: null,
            mapField3: false,
            mapField0: false,
            brand_has_merchant: [],
            stepper: [false, true, true, true],
            current_tab: 'vertical-tab-one',
            campaign_name: '',
            campaign_desc: '',
            merchant_length: null,
            merchant_counter: 1,
            merchant_counter_array: [0],
            follower: false,
            campaignStarter: false,
            //redirect = false
            //
            //
            unmapped_files : [],
            unmappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: ''
            },
            unmappedModel: false,
            data:[],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            deleteKeys:[],
            user_id: null,
            map_status: null,
            stored_file_name: null,
            file_name: null,
            userGroup: null,
            id: null,
            campaign_response: [],
            activer2: {
                '0': true,
                '1': true,
                '2': true,
                '3': true,
                '4': true,
                '5': true,
                '6': true,
                '7': true,
                '8': true,
                '9': true,
                '10': true,
                '11': true,
            },
            sku_list1: [],
            is_download: false,
            uploadDropdown: false,
            merchant2_display_data: [],
            merchant_file_name: null,
            merchant3_data: [],
            isSubmit: false,
            selectedFile: null,
            brand_file_uploaded: [],
            timer: null,
            scheme_master_data: [],
            scheme_master_list: [],
            scheme_mapping_file_name: '',
            scheme_mapping_data: [],
            scheme_flag: 0,
            scheme_master_list1: [],
            selectedSchemeFile: '',
            scheme_file_name: '',
            scheme_mapping_stored_file_name: '',
            merchant_master_list: [],
            merchant_monitor: 0,
            scheme_monitor: 0,
            scheme_activer: [],
            merchant_activer: [],
            party_master_id: null,
            emiMenus:[],
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:[],
            chainValue:[],
            storeList:[],
            storeValue: []
        };
        this.myRef = React.createRef();
        this.myRef2 = React.createRef();
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    changeTenure(index, month, checked) {
        const bankOptions = this.state.bankOptions.map((bank_value, bank_index) => {
            if (index === bank_index) {
                return {
                    ...bank_value,
                    [month]: checked.target.checked
                };
            }
            return bank_value;
        });
        this.setState({bankOptions, mapField2: false});
    }

    onChangera(){
        console.log("Hello");
    }

    setDescription = (optionSelected) => {
        this.setState({ selectedDescription: optionSelected });
        console.log(this.state.selectedDescription)
    };
    updateSKU = (optionSelected) => {
        this.setState({ selectedSKU: optionSelected.value })
    };
    updatePrice = (optionSelected) => {
        this.setState({ selectedPrice: optionSelected.value })
    };

    toggleunmappedModel() {
        this.setState({
            unmappedModel: !this.state.unmappedModel
        })
    }

    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    handleChange(checked) {
        //console.log(e.target.value);
        this.setState({
            checked
        });
    }


    fileUploadHandler = () => {
        const timer1 = (Date.now()).toString();
        //console.log(timer1);
        this.setState({
            timer: timer1,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        let random_string = timer1 + '_' + decoded._id + '_';
        data.append('file', this.state.selectedFile);
        data.append('fileType', this.state.fileType);
        data.append('userID', decoded._id);
        data.append('timer', this.state.timer);
        data.append('timer1', timer1);
        data.append('random_string', random_string);
        // let random_string = Date.now()+'_'+req.body.userID+'_';
        data.append('userGroup', decoded.userGroup);
        if(this.state.selectedFile == null){
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit: false,
                loading: false
            });
        }
        else{
            var file = this.state.selectedFile;
            var ext = this.getFileExtension(file.name);
            console.log(file.name);
            console.log(ext);
            if (ext === 'csv') {
                axios.post(config.get('API_URL') + "/brandemi/upload_merchant_master/", data, {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                    .then(res => {
                        console.log(res);
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            merchant_file_name: random_string + file.name,
                            merchant3_data: res.data,
                            file_name: file.name
                        });
                        //console.log(res.data.notify);
                        //console.log(res.data.inconsistent);

                        this.handleNotificationClick("tr", 1, "The file has been successfully uploaded");
                        this.setState({
                            isSubmit: true,
                            current_tab: 'vertical-tab-four',
                            stepper: {...this.state.stepper, [3]:false}
                        });


                        // this.setState({
                        //     isSubmit: false,
                        //     loading: false,
                        //     notify: res.data.notify,
                        //     merchant_file_name: random_string + file.name,
                        //     merchant3_data: res.data
                        // });
                        console.log(res.data);
                        this.openSectionToMap(true);



                        // if (res.data.inconsistent === 1){
                        //     this.handleNotificationClick("tr", 3, "There are inconsistencies");
                        // }
                        // else{
                        //     this.handleNotificationClick("tr", 3, res.data.error);
                        // }
                        this.setState({
                            isSubmit: false,
                            loading: false
                        });

                    })
                    .catch(err => { // then print response status
                        this.handleNotificationClick("tr", 3, "Something Wrong!");
                        this.setState({
                            isSubmit: false,
                            loading: false
                        });
                        // this.openSectionToMap(true); // remove and place in success block
                    })
            }
            else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    isSubmit: false,
                    loading: false
                });
            }
        }
    };

    fileUploadHandlerScheme = () => {
        const timer1 = (Date.now()).toString();
        //console.log(timer1);
        this.setState({
            timer: timer1,
            isSubmit: true,
            loading: true,
            current_tab: 'vertical-tab-three',
            stepper: {...this.state.stepper, [2]:false}
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        let random_string = timer1 + '_' + decoded._id + '_';
        data.append('file', this.state.selectedSchemeFile);
        data.append('fileType', this.state.fileType);
        data.append('userID', decoded._id);
        data.append('timer', this.state.timer);
        data.append('timer1', timer1);
        data.append('random_string', random_string);
        // let random_string = Date.now()+'_'+req.body.userID+'_';
        data.append('userGroup', decoded.userGroup);
        if(this.state.selectedSchemeFile == null){
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit: false,
                loading: false
            });
        }
        else{
            var file = this.state.selectedSchemeFile;
            var ext = this.getFileExtension(file.name);
            console.log(file.name);
            console.log(ext);
            if (ext === 'csv') {
                axios.post(config.get('API_URL') + "/brandemi/upload_scheme_mapping/", data, {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                    .then(res => {
                        console.log(res);
                        res.data.map((values, index) =>{
                            this.setState({
                                scheme_master_list: {...this.state.scheme_master_list, [values.scheme_id]: true}
                            })
                        })
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            scheme_mapping_stored_file_name: random_string + file.name,
                            scheme_mapping_data: res.data,
                            scheme_flag: 1,
                            scheme_mapping_file_name: file.name
                        });
                        //console.log(res.data.notify);
                        //console.log(res.data.inconsistent);


                        this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");


                        // this.setState({
                        //     isSubmit: false,
                        //     loading: false,
                        //     notify: res.data.notify,
                        //     merchant_file_name: random_string + file.name,
                        //     merchant3_data: res.data
                        // });
                        console.log(res.data);
                        this.openSectionToMap(true);



                        if (res.data.inconsistent === 1){
                            this.handleNotificationClick("tr", 3, "There are inconsistencies");
                        }
                        else{
                            this.handleNotificationClick("tr", 3, res.data.error);
                        }
                        this.setState({
                            isSubmit: false,
                            loading: false
                        });

                    })
                    .catch(err => { // then print response status
                        this.handleNotificationClick("tr", 3, "Something Wrong!");
                        this.setState({
                            isSubmit: false,
                            loading: false
                        });
                        // this.openSectionToMap(true); // remove and place in success block
                    })
            }
            else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    isSubmit: false,
                    loading: false
                });
            }
        }
    };




    downloadCSV = (file_id) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: "/brandemi/download_csv_brand?file_id=" + file_id,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName = xhr.getResponseHeader('Content-Disposition').split("=")[1];
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    onChangeHandler = event => {
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
        if (ext === 'csv') {
            this.setState({
                selectedFile: file,
                file_name: file.name
            });
        } else {
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                selectedFile: file
            });
        }
    };

    onChangeHandlerScheme = event => {
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
        if (ext === 'csv') {
            this.setState({
                selectedSchemeFile: file,
                scheme_file_name: file.name
            });
        } else {
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                selectedSchemeFile: file
            });
        }
    };

    getMerchantMappingData(){
        if(this.state.party_master_id != null){
            if ($.fn.DataTable.isDataTable('#brandMerchantMasterViewTable')) {
                $('#brandMerchantMasterViewTable').DataTable().destroy();
            }
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            axios.get(config.get('API_URL') + '/brandemi/view_merchant_maintainer',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params: {
                    party_master_id: this.state.party_master_id
                }
            }).then(response => {
                response.data.map((value, index) => {
                    this.setState({
                        merchant_activer: {...this.state.merchant_activer, [value.id]: true}
                    })
                })
                //console.log(response.data);
                this.setState({
                    merchant2_display_data: response.data
                });
                $('#brandMerchantMasterViewTable').DataTable();
                this.setState({
                    loading: false,
                    user_id: decoded._id
                });
            });
        }
    }

    _refreshCampaign() {
        if ($.fn.DataTable.isDataTable('#campaignTable')) {
            $('#campaignTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_campaign_brand',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            console.log(response);
            this.setState({
                campaign_response: response.data
            });
            $('#campaignTable').DataTable();
            this.setState({
                loading: false
            })

        });
    }

    mapData(id, map_status, stored_file_name, user_type, user_id, file_name){
        this.setState({
            id: id,
            map_status: map_status,
            stored_file_name: stored_file_name,
            userGroup: user_type,
            user_id: user_id,
            file_name: file_name
        });
        this.openSectionToMap(true);
    }

    openSectionToMap = (status) => {
        console.log(this.state.userGroup);
        this.setState({
            mapField: status
        })
    };

    updateMapVisiblity = (value) => {
        console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };

    changeValue(index, value, checked) {
        const bankOptions = this.state.bankOptions.map((bank_value, bank_index) => {
            if (index === bank_index) {
                if(value === 'bank_type' && checked.value === 'NA'){
                    this.setState({
                        disabler_list: {...this.state.disabler_list, [index]:true}
                    });
                    return {
                        ...bank_value,
                        [value]: checked.value,
                        ['bank_value']: 0
                    };
                }
                else if(value === 'bank_type' && checked.value !== 'NA'){
                    this.setState({
                        disabler_list: {...this.state.disabler_list, [index]:false}
                    });
                    return {
                        ...bank_value,
                        [value]: checked.value
                    };
                }
                else{
                    return {
                        ...bank_value,
                        [value]: checked.value
                    };
                }
            }
            return bank_value;
        });
        this.setState({bankOptions});
    }

    retrieveStateData(){
        console.log("retrieving state data");
        axios.get(config.get('API_URL') + '/brandemi/get_state',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            const state_data = response.data.map((values, index) =>{
                console.log(values['state_name']);
                return{
                    ['value']: values['state_id'],
                    ['label']: values['state_name']
                };
            });
            this.setState({
                state_data: state_data,
                mapField2: false,
                state_display_data: response.data,
                loading: false
            });
        });
    }

    // getSchemeMasterDataView(){
    //     if ($.fn.DataTable.isDataTable('#brandSchemeMasterViewTable')) {
    //         $('#brandSchemeMasterViewTable').DataTable().destroy();
    //     }
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_schemes_master_data', {
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             party_master_id: this.state.party_master_id
    //         }
    //     }).then(response => {
    //         console.log(response);
    //         response.data.map((value, index) => {
    //             this.setState({
    //                 scheme_activer: {...this.state.scheme_activer, [value.id]:true }
    //             });
    //         });
    //         this.setState({
    //             scheme_master_data: response.data
    //         });
    //         $('#brandSchemeMasterViewTable').DataTable();
    //     });
    //     return null;
    // }

    getSchemeMasterDataView(){
        if ($.fn.DataTable.isDataTable('#brandSchemeMasterViewTable')) {
            $('#brandSchemeMasterViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_new_schemes_master', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            console.log(response);
            response.data.map((value, index) => {
                this.setState({
                    scheme_activer: {...this.state.scheme_activer, [value.id]:true }
                });
            });
            this.setState({
                scheme_master_data: response.data
            });
            $('#brandSchemeMasterViewTable').DataTable();
        });
        return null;
    }

    retrieveCityData(){
        console.log("retrieving city data");
        axios.get(config.get('API_URL') + '/brandemi/get_city',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            const city_data = response.data.map((values, index) =>{
                if (index == 0) {
                    this.setState({selectedCity: values['city_name']});
                }
                console.log(values['city_name']);
                return{
                    ['value']: values['city_id'],
                    ['label']: values['city_name']
                };
            });
            this.setState({city_data: city_data, mapField2: false});
            this.setState({
                city_display_data: response.data
            });
            this.setState({
                loading: false
            });
        });
    }

    componentDidMount(){
        this.getPartyID();
        this._getAllMerchants();
        this.setState({
            _notificationSystem: this.refs.notificationSystem
        });
        //var _notificationSystem = this.refs.notificationSystem;
        this.validator = new SimpleReactValidator();
    }

    _getAllMerchants(){
        axios.post(config.get('API_URL')+'/brandemi/get-merchant',{},{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {

                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
        });
    }

    changeMerchant1(optionSelected){
        console.log(optionSelected);
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.merchantList.findIndex(obj => obj.value==mids.value);
                this.state.merchantList.move(index,0).join(',');
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: []
        }, () =>{
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        });
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

    }

    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/brandemi/get-chain',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            console.log(response.data);
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name, value1: chain.merchant_code, merch_name: chain.merchant_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }
    changeChain(optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                this.state.chainList.move(index,0).join(',');
            });
        }

        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: []
        });

        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

        this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);


    }
    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/brandemi/get-store', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            console.log(response.data);
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name, value1:store.merchant_code, value2: store.chain_code, chain_name: store.chain_name, merch_name: store.merchant_name})
            });
            this.setState({
                storeList:storeList
            })
        });
    }
    changeStore(optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                var index = this.state.storeList.findIndex(obj => obj.value==sids.value);
                this.state.storeList.move(index,0).join(',');
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        // this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,this.state.frequency,
        //     this.state.yestSend, this.state.todSend);
    }

    // componentWillMount(){
    //     this.generateBankList();
    // }
    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
            this._refreshSku_Show_View();
            // this.brand_has_merchant_finder();
            this._refreshCampaign();
            this.getMerchantMappingData();
            this.getSchemeMasterDataView();
        });
    }

    _refreshSku_Show_View() {
        if ($.fn.DataTable.isDataTable('#sku_showTable')) {
            $('#sku_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/view_brand_sku',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id,
            }
        }).then(response => {
            console.log(response.data);
            response.data.map((values, index) => {
                this.setState({
                    sku_list1: {...this.state.sku_list1, [values.sku]:true},
                })
            })
            this.setState({
                raw_display_data: response.data
            });
            $('#sku_showTable').DataTable();
            this.setState({
                loading: false
            });
        });
    }

    // brand_has_merchant_finder(){
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_brand_has_merchant',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             user_id: decoded._id
    //         }
    //     }).then(response => {
    //         console.log(response.data);
    //         let vary1 = response.data.map((values, index) => {
    //             return{
    //                 ['value']: values['merchant_code'],
    //                 ['label']: values['merchant_name'],
    //                 ['value1']: values['merchant_id']
    //             };
    //         });
    //         console.log(response.data.length);
    //         // if (response.data.length > 0){
    //         //     let merchant_counter_array = this.state.merchant_counter_array.concat[0];
    //         //     this.setState({
    //         //         merchant_counter: 1,
    //         //         merchant_counter_array
    //         //     })
    //         // }
    //         this.setState({
    //             brand_has_merchant: vary1,
    //             merchant_length: response.data.length
    //         });
    //     })
    //    }
    // generateBankList() {
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_bank_list',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     }).then(response => {
    //         console.log(response.data);
    //         response.data.map((value, index) => {
    //             if (value.issuer_bank_code != "ISB0000000004" || value.issuer_bank_display_name != "ISB0000000012" || value.issuer_bank_display_name != "XXXXXXXXXXXXX"){
    //                 this.setState({
    //                     bank_name_list1: {...this.state.bank_name_list1, [value.issuer_bank_code]:value.issuer_bank_display_name},
    //                 });
    //             }
    //         });
    //         this.setState({
    //             the_bank_list: response.data,
    //             loading: false
    //         });
    //     });
    // }

    // openSectionToSKU = (status) => {
    //     this.setState({
    //         mapField2: status
    //     })
    // };

    openSectionToBanks = (status) => {
        if (this.state.sku_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one SKU");
        }
        else{
            this.setState({
                mapField2: status,
                current_tab: 'vertical-tab-two',
                stepper: {...this.state.stepper, [1]:false},
            });
        }
    }


    sendEMIMappings(status){
        let value1 = this.validateValue();
        let value2 = this.validateDate();
        let value3 = this.validateTenure();
        // console.log(value1);
        // console.log(value2);
        // console.log(value3);
        if(this.state.scheme_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one scheme");
        }
        else{
            this.setState({
                mapField2: status,
                current_tab: 'vertical-tab-three',
                stepper: {...this.state.stepper, [2]:false},
            });
        }
    }

    // merchantSubmitHandler(){
    //     if(this.state.merchant_monitor === 0){
    //         this.handleNotificationClick("tr", 3, "Select atleast one merchant");
    //     }
    //     else{
    //         this.setState({
    //             isSubmit: true,
    //             current_tab: 'vertical-tab-four',
    //             stepper: {...this.state.stepper, [3]:false}
    //         });
    //     }
    // }

    merchantSubmitHandler(){
        if(this.state.merchantValue.length === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one merchant");
        }
        else{
            this.setState({
                isSubmit: true,
                current_tab: 'vertical-tab-four',
                stepper: {...this.state.stepper, [3]:false}
            });
        }
    }

    openSectionToProduct = (status) => {
        let value2 = this.validateDate();
        if (this.state.sku_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one SKU");
        }
        else if(this.state.scheme_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one scheme");
        }
        else if(this.state.merchantValue.length === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one merchant");
        }
        else if(this.state.campaign_name == null || this.state.campaign_name == '')
        {
            this.handleNotificationClick("tr", 3, "Please enter promotion name");
        }
        else if(this.state.campaign_desc == null || this.state.campaign_desc == '')
        {
            this.handleNotificationClick("tr", 3, "Please enter promotion description");
        }
        else if(value2 != 0){
            this.handleNotificationClick("tr", 3, "Please insert valid date range");
        }
        else if(((this.state.maxTxnAmount)*1) <= 0 || (this.state.maxTxnAmount === '')){
            this.handleNotificationClick("tr", 3, "Please insert value greater than 0");
        }
        else{
            this.setState({
                mapField0: status,
                newConfirmationModel: !this.state.newConfirmationModel
            });
        }

    }

    validateDate(){
        if(this.state.startDate > this.state.endDate){
            //console.log("yay");
            //this.handleNotificationClick("tr", 3, "Select valid date range");
            console.log("error");
            return 1;
        }
        else{
            return 0;
        }
    }

    validateTenure(){
        let returner = 0;
        let value1 = this.state.bank_name_list.map((value, index) => {
            if (this.state.bankOptions[index]["M3"] === false && this.state.bankOptions[index]["M6"] === false && this.state.bankOptions[index]["M9"] === false && this.state.bankOptions[index]["M12"] === false && this.state.bankOptions[index]["M18"] === false && this.state.bankOptions[index]["M24"] === false && this.state.isEMI[index] == true)
            {
                this.handleNotificationClick("tr", 3, "Select atleast one tenure at bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
        });
        return returner;
        //console.log("yay");
    }

    validateValue(){
        let returner = 0;
        let value1 = this.state.bank_name_list.map((value, index) => {
            if ((this.state.brand_subvention_value[index])*1 < 0 || (this.state.brand_subvention_value[index] === '')){
                this.handleNotificationClick("tr", 3, "Enter positive value at brand subvention value of bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
            else if ((this.state.bank_subvention_list[index] === 'Percent' || this.state.bank_subvention_list[index] === 'Cashback') && (this.state.bank_subvention_value[index])*1 < 0 || (this.state.bank_subvention_value[index] === ''))
            {
                this.handleNotificationClick("tr", 3, "Enter positive value at bank subvention value of bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
            else if ((this.state.maximum_cashback[index])*1 < 0 || (this.state.maximum_cashback[index] === ''))
            {
                this.handleNotificationClick("tr", 3, "Enter positive value at maximum cashback value of bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
        });
        if ((this.state.maxTxnAmount)*1 < 0 || (this.state.maxTxnAmount === '')){
            this.handleNotificationClick("tr", 3, "Enter positive value at maximum cashback allowed per card.");
            console.log("error");
            returner = 1;
        }
        return returner;
    }



    // sendEMIMappings2(valuer){
    //     let value1 = this.validateValue();
    //     let value2 = this.validateDate();
    //     let value3 = this.validateTenure();
    //     console.log(value1);
    //     console.log(value2);
    //     console.log(value3);
    //     if(1){
    //         //value1 === 0 && value2 === 0 && value3 === 0 && this.state.scheme_monitor_incr > 0
    //         this.setState({
    //             mapField3: true,
    //             current_tab: 'vertical-tab-three',
    //             stepper: {...this.state.stepper, [2]:false}
    //         })
    //         this.state.scheme_master_data.map((value, index) => {
    //             // let index_val = value.bank_name;
    //             let bankvaluer = '';
    //             // console.log(bankvaluer.value);
    //             if(value.bank_name == 'AMEX BANK'){
    //                 bankvaluer = '0';
    //                 console.log("Hello");
    //             }
    //             else if(value.bank_name == 'AXIS BANK'){
    //                 bankvaluer = '1';

    //             }
    //             else if(value.bank_name == 'CITIBANK'){
    //                 bankvaluer = '2';
    //             }
    //             else if(value.bank_name == 'HDFC Bank'){
    //                 bankvaluer = '3';
    //             }
    //             else if(value.bank_name == 'HSBC Bank'){
    //                 bankvaluer = '4';
    //             }
    //             else if(value.bank_name == 'ICICI Bank'){
    //                 bankvaluer = '5';
    //             }
    //             else if(value.bank_name == 'INDUSIND BANK'){
    //                 bankvaluer = '6';
    //             }
    //             else if(value.bank_name == 'KOTAK BANK'){
    //                 bankvaluer = '7';
    //             }
    //             else if(value.bank_name == 'RBL BANK'){
    //                 bankvaluer = '8';
    //             }
    //             else if(value.bank_name == 'SBI CARD'){
    //                 bankvaluer = '9';
    //             }
    //             else if(value.bank_name == 'STANDARD CHARTERED BANK'){
    //                 bankvaluer = '10';
    //             }
    //             else if(value.bank_name == 'YES BANK'){
    //                 bankvaluer = '11';
    //             }
    //             const bankOptions = this.state.bankOptions.map((bank_value, bank_index) => {
    //                 if (bank_value.name === value.bank_name) {
    //                     return {
    //                         ...bank_value,
    //                         ['M3']: (value.m3)? true : false,
    //                         ['M6']: (value.m6)? true : false,
    //                         ['M9']: (value.m9)? true : false,
    //                         ['M12']: (value.m12)? true : false,
    //                         ['M18']: (value.m18)? true : false,
    //                         ['M24']: (value.m24)? true : false,
    //                     };
    //                 }
    //                 return bank_value;
    //             });

    //             this.setState({
    //                 bankOptions,
    //                 mapField2: false,
    //             });

    //             this.setState({
    //                 activer: {...this.state.activer, [bankvaluer]:true},
    //                 isEMI: {...this.state.isEMI, [bankvaluer]:(value.is_emi)? true: false},
    //                 isUpfront: {...this.state.isUpfront, [bankvaluer]:(value.is_upfront)? true: false},
    //                 zeroCost: {...this.state.zeroCost, [bankvaluer]:(value.is_zero_cost)? true: false},
    //                 brand_subvention_list: {...this.state.brand_subvention_list, [bankvaluer]:value.brand_sub},
    //                 brand_subvention_value: {...this.state.brand_subvention_value, [bankvaluer]:value.brand_sub_amount},
    //                 maximum_cashback: {...this.state.maximum_cashback, [bankvaluer]:value.cashback},
    //             })
    //         })
    //     }
    //     else{
    //         console.log("Failure");
    //         this.setState({
    //             mapField2: false
    //         });
    //     }

    //     //else{
    //     //    this.openSectionToSKU(value);
    //     //}
    // }

    merchantValidator(value) {
        this.setState({
            //newConfirmationModel: !this.state.newConfirmationModel
            current_tab: 'vertical-tab-four',
            stepper: {...this.state.stepper, [3]:false}
        });
    }



    multiSelectValidator(index){
        if (index === this.state.selectedMerchantSubvention){
            return true;
        }
        else{
            return false;
        }
    }

    refineEnabler(index){

    }

    onTurnRefine = (value) => {
        console.log("hi");
        this.setState({
            refineSearch: value
        })
        // if (value == false){
        //     let refinerMerch = [...this.state.refinerMerch];     // create the copy of state array
        //     refinerMerch[0] = false;
        //     refinerMerch[1] = false;
        //     refinerMerch[2] = false;
        //     refinerMerch[3] = false;
        //     refinerMerch[4] = false;
        //     this.setState({
        //         refinerMerch
        //     })
        // }
    }

    updateSKUVisiblity = (value) => {
        this.setState({
            mapField2: value
        })
    };

    updateBrandSubvention = (index, optionSelected) => {
        this.setState({
            brand_subvention_list: {...this.state.brand_subvention_list, [index]:optionSelected.value },
            mapField2: false
        })
    };

    updateState = (optionSelected) => {
        if (optionSelected != null){
            this.setState({
                selectedState: {...this.state.selectedState, [optionSelected.value]: optionSelected.value},
                mapField2: false
            })
        }
        else{
            this.setState({
                selectedState: [],
                mapField2: false
            })
        }
    };


    // _getStateList = async() => {
    //     const options = [];
    //     let res = await axios.get(config.get('API_URL') + "/brandemi/get_state_values", {
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //     });

    //     await res.data.map((str, index) => {
    //         options.push({
    //             value: str.state_id,
    //             label: str.state_name
    //         });
    //     })
    //     console.log(options)
    //     const sleep = ms =>
    //         new Promise(resolve => {
    //             setTimeout(() => {
    //             resolve();
    //             }, ms);
    //         });

    //     const optionsPerPage = 10;

    //     const loadOptions = async (search, page) => {
    //         await sleep(1000);

    //         let filteredOptions;
    //         if (!search) {
    //             filteredOptions = options;
    //         }
    //         else {
    //             const searchLower = search.toLowerCase();
    //             filteredOptions = options.filter(({ label }) =>
    //             label.toLowerCase().includes(searchLower)
    //             );
    //         }

    //         const hasMore = Math.ceil(filteredOptions.length / optionsPerPage) > page;
    //         const slicedOptions = filteredOptions.slice(
    //             (page - 1) * optionsPerPage,
    //             page * optionsPerPage
    //         );

    //         return {
    //             options: slicedOptions,
    //             hasMore
    //         };
    //     };
    // }

    _getMerchList = async (merch_config, search, loadedOptions, { page } ) => {
        let columna = '';
        let columnb = '';
        let columnc = '';
        if(merch_config === "State_Level"){
            columna = 'state_id';
            columnb = 'state_name';
            columnc = 'state_id';
        }
        if(merch_config === "City_Level"){
            columna = 'city_id';
            columnb = 'city_name';
            columnc = 'city_id';
        }
        if(merch_config === "Merchant_Level"){
            columna = 'merchant_id';
            columnb = 'merchant_name';
            columnc = 'merchant_code';
        }
        if(merch_config === "Chain_Level"){
            columna = 'chain_id';
            columnb = 'chain_name';
            columnc = 'chain_code';
        }
        if(merch_config === "Store_Level"){
            columna = 'store_id';
            columnb = 'store_name';
            columnc = 'store_code';
        }
        this.setState({
            slicedMerchValues: []
        });
        let res = await axios.get(config.get('API_URL') + "/brandemi/get_merch_values/?merch_config="+merch_config+"&search="+search+"&page="+page, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        });
        //console.log(res.data);
        let hasMore = false;
        if(Array.isArray(res.data) && res.data.length) {
            hasMore = true;
        }
        res.data.map((str, index) => {
            console.log(columna);
            console.log(columnb);
            this.state.slicedMerchValues.push({value: str[columna], label: str[columnb], value1: str[columnc]})
        });
        //console.log(this.state.slicedMerchValues);
        return {
            options: this.state.slicedMerchValues,
            hasMore: hasMore,
            additional: {
                page: page + 1,
            },
        };
    };

    _getRefineList = async (merch_config, search, loadedOptions, { page } ) => {
        console.log(merch_config);
        let columna = '';
        let columnb = '';
        let columnc = '';
        let columnd = '';
        let relevant_id = '$ab';
        let select_option = [{
            value: 9, label:'Select All', value1: 9
        }]

        if(merch_config === "Merchant_Level"){
            columna = 'merchant_id';
            columnb = 'merchant_name';
            columnc = 'merchant_code';
            relevant_id = this.state.city_ida.value;
        }
        if(merch_config === "Chain_Level"){
            columna = 'chain_id';
            columnb = 'chain_name';
            columnc = 'chain_code';
            relevant_id = this.state.merchant_ida.value1;
            console.log(this.state.merchant_ida);
        }
        if(merch_config === "Store_Level"){
            columna = 'store_id';
            columnb = 'store_name';
            columnc = 'store_code';
            relevant_id = this.state.chain_ida.value;
        }
        this.setState({
            slicedMerchValues: []
        });
        let res = await axios.get(config.get('API_URL') + "/brandemi/get_refined_values/?merch_config="+merch_config+"&relevant_id="+relevant_id+"&search="+search+"&page="+page, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        });
        //console.log(res.data);
        let hasMore = false;
        if(Array.isArray(res.data) && res.data.length) {
            hasMore = true;
        }
        this.state.slicedMerchValues.push({label: 'Select All', options: select_option})
        res.data.map((str, index) => {
            console.log(columna);
            console.log(columnb);
            let vary_option = [{
                value:str[columnc], label: str[columnb], value1: str[columnc]
            }];
            //this.state.slicedMerchValues.push({value: str[columnc], label: str[columnb], value1: str[columnc]})
            this.state.slicedMerchValues.push({label: 'Store', options: vary_option})
        });
        //console.log(this.state.slicedMerchValues);
        return {
            options: this.state.slicedMerchValues,
            hasMore: hasMore,
            additional: {
                page: page + 1,
            },
        };
    };

    updateMerchValues = (optionSelected, valuer) => {
        //console.log(optionSelected);
        if (optionSelected === null){
            this.setState({
                selectedMerchValues: [],
                mapField2: false
            });
        }
        else{
            this.setState({
                selectedMerchValues: optionSelected,
                merchant_ida: valuer,
                mapField2: false
            });
        }
    };


    updateMerchRefineValues = (optionSelected, valuer) => {
        //console.log(optionSelected);
        //console.log(valuer);
        if (optionSelected === null){
            this.setState({
                selectedMerchValues: [],
                selectedRefineSubvention: [],
                mapField2: false
            });
        }
        else{
            if (optionSelected == 'Merchant_Level')
            {
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    merchant_ida: valuer,
                    chain_ida: '',
                    store_ida: '',
                    mapField2: false
                });
            }
            else if (optionSelected == 'Chain_Level')
            {
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    chain_ida: valuer,
                    store_ida: '',
                    mapField2: false
                });
            }
            else if (optionSelected == 'store_Level')
            {
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    store_ida: valuer,
                    mapField2: false
                });
            }
        }
    };

    updateCity = (optionSelected) => {
        this.setState({
            selectedCity: optionSelected.value,
            mapField2: false
        })
    };

    updateMerchantSubvention = (optionSelected) => {
        let refinerMerch = [...this.state.refinerMerch];     // create the copy of state array
        refinerMerch[0] = false;
        refinerMerch[1] = false;
        refinerMerch[2] = false;
        refinerMerch[3] = false;
        refinerMerch[4] = false;

        if (optionSelected.value === "All_Level")
        {
            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "State_Level")
        {
            refinerMerch[0] = true;
            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "City_Level")
        {
            refinerMerch[0] = true;
            refinerMerch[1] = true;

            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "Merchant_Level")
        {
            refinerMerch[0] = true;
            refinerMerch[1] = true;
            refinerMerch[2] = true;

            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "Chain_Level")
        {
            refinerMerch[0] = true;
            refinerMerch[1] = true;
            refinerMerch[2] = true;
            refinerMerch[3] = true;


            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false

            });
        }
        else{
            refinerMerch[0] = true;
            refinerMerch[1] = true;
            refinerMerch[2] = true;
            refinerMerch[3] = true;
            refinerMerch[4] = true;

            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
    };

    updateBankSubvention = (index, optionSelected) => {
        if (optionSelected.value === "NA"){
            this.setState({
                disabler_list: {...this.state.disabler_list, [index]:true}
            });
        }
        else{
            this.setState({
                disabler_list: {...this.state.disabler_list, [index]:false}
            });
        }
        this.setState({
            bank_subvention_list: {...this.state.bank_subvention_list, [index]:optionSelected.value},
            mapField2: false
        })
    };

    disabler(index){
        this.setState({
            disabler_list: {...this.state.disabler_list, [index]:false}
        });
    }

    handleFromChange = date => {
        this.setState({
            startDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    handleToChange = date => {
        this.setState({
            endDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    changeSKU = (sku, checked) => {
        let sku_monitor_incr = this.state.sku_monitor;
        if (checked === true){
            this.setState((state) => ({
                sku_monitor: state.sku_monitor + 1
            }))
        }
        else{
            this.setState((state) => ({
                sku_monitor: state.sku_monitor - 1
            }))
        }
        this.setState({
            sku_list: {...this.state.sku_list, [sku]:checked},
            mapField2: false,
            mapField: false
        });
    };

    changeScheme = (id, checked) => {
        let scheme_monitor_incr = this.state.scheme_monitor;
        if (checked === true){
            this.setState((state) => ({
                scheme_monitor: state.scheme_monitor + 1
            }))
        }
        else{
            this.setState((state) => ({
                scheme_monitor: state.scheme_monitor - 1
            }))
        }
        this.setState({
            scheme_master_list: {...this.state.scheme_master_list, [id]:checked}
        });
    };


    changeMerchant = (id, checked) => {
        let merchant_monitor_incr = this.state.merchant_monitor;
        if (checked === true){
            this.setState((state) => ({
                merchant_monitor: this.state.merchant_monitor + 1
            }))
        }
        else{
            this.setState((state) => ({
                merchant_monitor: this.state.merchant_monitor - 1
            }))
        }
        this.setState({
            merchant_master_list: {...this.state.merchant_master_list, [id]:checked}
        });
    };

    skuMapping() {
        //console.log("hello world");
    }

    toggleConfirmationModel() {
        //if (this.state.sku_list.length == 0){
        if (this.state.sku_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one SKU");
        }
        else{
            this.setState({
                newConfirmationModel: !this.state.newConfirmationModel
            });
        }
    }

    openSectionToMap = (status) => {
        this.setState({
            mapField: status
        })
    };

    sendBankMappings(value) {
        let value1 = 0;
        //console.log(this.state.activer);
        let value2 = this.state.bank_name_list.map((values, index) => {
            if(this.state.activer[index] === true){
                value1 = 1;
            }
        });
        if (value1 === 0) {
            this.handleNotificationClick("tr", 3, "Select atleast one bank.");
        }
        else {
            this.openSectionToMap(value);
        }
        if(this.myRef.current){
            this.myRef.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            })
        }
    }

    updateMapVisiblity = (value) => {
        //console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };

    changeActiver(index, checked) {
        this.setState({
            activer: {...this.state.activer, ['' + index + '']:checked.target.checked },
            mapField: false

        });
    }

    changeEMIstatus(index, checked) {
        this.setState({
            isEMI: {...this.state.isEMI, [index]:checked.target.checked},
            mapField2: false
        })
    }

    changeZeroCoststatus(index, checked) {
        this.setState({
            zeroCost: {...this.state.zeroCost, [index]:checked.target.checked},
            mapField2: false
        })
    }

    goBack = () => {
        this.props.history.push('/admin/view-promotions')
    }

    changeisUpfrontstatus(index, checked) {
        this.setState({
            isUpfront: {...this.state.isUpfront, [index]:checked.target.checked},
            mapField2: false
        })
    }

    campaignDropdown = () => {
        this.setState({
            campaignStarter: true
        })
    }

    sendCompleteScheme = () =>{
        this.setState({

        });
        const data = new FormData();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        //let merchant_final_data2 = this.state.merchant2_display_data

        //if(this.state.refineSearch == true){
        data.append('bank_list', JSON.stringify(this.state.bank_name_list));
        data.append('activer', JSON.stringify(this.state.activer));
        data.append('zero_cost', JSON.stringify(this.state.zeroCost));
        data.append('is_emi', JSON.stringify(this.state.isEMI));
        data.append('brand_sub_list', JSON.stringify(this.state.brand_subvention_list));
        data.append('brand_sub_value', JSON.stringify(this.state.brand_subvention_value));
        data.append('tenures', JSON.stringify(this.state.bankOptions));
        data.append('sku_list', JSON.stringify(this.state.sku_list));
        data.append('user_id', decoded._id);
        data.append('start_date', this.state.startDate);
        data.append('end_date', this.state.endDate);
        data.append('max_cashback', this.state.maxTxnAmount);
        data.append('isUpfront', JSON.stringify(this.state.isUpfront));
        data.append('maximum_cashback', JSON.stringify(this.state.maximum_cashback));
        data.append('state_data', JSON.stringify(this.state.state_ida));
        data.append('city_data', JSON.stringify(this.state.city_ida));
        data.append('merchant_data', JSON.stringify(this.state.merchant_ida));
        data.append('chain_data', JSON.stringify(this.state.chain_ida));
        data.append('store_data', JSON.stringify(this.state.store_ida));
        data.append('isRefine', 1);
        data.append('camp_name', this.state.campaign_name);
        data.append('camp_desc', this.state.campaign_desc);
        data.append('merchant_final_data', JSON.stringify(this.state.merchant3_data));
        data.append('file_name', this.state.file_name);
        data.append('stored_file_name', this.state.merchant_file_name);
        data.append('scheme_master_list', JSON.stringify(this.state.scheme_master_list))
        data.append('scheme_file_name', this.state.scheme_mapping_file_name);
        data.append('scheme_stored_file_name', this.state.scheme_mapping_stored_file_name);
        data.append('merchant_master_list', JSON.stringify(this.state.merchant_master_list));
        data.append('merchant_master_data', JSON.stringify(this.state.merchant2_display_data));
        data.append('party_master_id', this.state.party_master_id);
        data.append('merchant_list', JSON.stringify(this.state.merchantValue));
        data.append('chain_list', JSON.stringify(this.state.chainValue));
        data.append('store_list', JSON.stringify(this.state.storeValue));
        data.append('freeemi_wallet', false);
        // }

        axios.post(config.get('API_URL') + '/brandemi/new_submit_subvention_scheme', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(res => {
            //console.log(res);
            // this.handleNotificationClick("tr", 1, "Data successfully uploaded");
            // this.toggleConfirmationModel();
            // const yourFunction = async () => {
            //     await new Promise(resolve => setTimeout(resolve, 3000)); // 3 sec
            //     console.log("Waited 5s");
            this.props.history.push('/admin/view-promotion-list')
            // };
            // yourFunction();

            //this.changeRedirect();
        }).catch(err => {

        })
    };

    whetherDisabled(index){
        if (this.state.brand_subvention_list[index] === "Percent"){
            return false;

        }
        else{
            return true;
        }
    }

    evalMerchantCounter(){
        //if (this.state.merchant_counter > 0){
        //let merchant_counter_array = this.state.merchant_counter_array.concat[0];
        this.setState({
            merchant_counter: this.state.merchant_counter + 1,
            merchant_counter_array: this.state.merchant_counter_array.concat([0])
        })
        //}
        // else{
        //     let merchant_counter_array = this.state.merchant_counter_array.concat[0];
        //     this.setState({
        //         merchant_counter: this.state.merchant_counter + 1,
        //         follower: !this.state.follower,
        //         merchant_counter_array
        //     })
        // }

    }

    negEvalMerchantCounter(){
        this.state.merchant_counter_array.pop()
        this.setState({
            merchant_counter: this.state.merchant_counter + 1,
            //merchant_counter_array: this.state.merchant_counter_array.pop()
        });
    }

    tabClicker(value){
        if(value == 1){
            this.setState({
                stepper: {...this.state.stepper, [1]: true},
                stepper: {...this.state.stepper, [2]: true},
                stepper: {...this.state.stepper, [3]: true}
            })
        }
    }

    selectAll(){
        this.setState({
            sku_monitor: 0
        })
        this.state.raw_display_data.map((values, index) => {
            console.log(values);
            console.log(this.state.sku_list);
            this.setState({
                sku_list: this.state.sku_list1,
                sku_monitor: this.state.raw_display_data.length
            });
        })
    }

    deSelectAll(){
        this.setState({
            sku_list: [],
            sku_monitor: 0
        })
    }

    selectAllPromotions(){
        this.setState({
            scheme_master_list: this.state.scheme_activer,
            scheme_monitor: this.state.scheme_master_data.length
        })
    }

    deselectAllPromotions(){
        this.setState({
            scheme_master_list: [],
            scheme_monitor: 0
        })
    }

    selectAllMerchants(){
        this.setState({
            merchant_master_list: this.state.merchant_activer,
            merchant_monitor: this.state.merchant2_display_data.length
        })

    }

    deselectAllMerchants(){
        this.setState({
            merchant_master_list: [],
            merchant_monitor: 0
        })

    }

    selectAllBanks(){
        this.setState({
            activer: this.state.activer2,
            mapField: false
        })
    }

    deSelectAllBanks(){
        this.setState({
            activer: {
                '0': false,
                '1': false,
                '2': false,
                '3': false,
                '4': false,
                '5': false,
                '6': false,
                '7': false,
                '8': false,
                '9': false,
                '10': false,
                '11': false
            },
            mapField: false
        })
    }

    render() {
        console.log(this.state.merchantValue);
        console.log(this.state.chainValue);
        console.log(this.state.storeValue);

        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        let scheme_data_master = this.state.scheme_master_data.map((value, index) =>{
            let timer2 = new Date(value.record_update_timestamp)
            timer2.setHours( timer2.getHours() + 5 );
            timer2.setMinutes( timer2.getMinutes() + 30 );
            // timer
            let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            let cashback_render = '';
            let brand_sub_render = value.brand_sub;
            let brand_sub_amount_render = value.brand_sub_amount;
            let tenure_render = value.tenure;
            let emi_typea = 'Non EMI';
            if (value.is_emi == 0 || value.is_emi == '0'){
                tenure_render = 'NA';
            }
            else if(value.is_emi == 1 || value.is_emi == '1'){
                emi_typea = 'Zero Cost' 
            }
            else if(value.is_emi == 2 || value.is_emi == '2'){
                emi_typea = 'Low Cost' 
            }
            if (value.is_cashback == 0 || value.is_cashback == '0'){
                cashback_render = 'No';
                brand_sub_render = 'NA';
                brand_sub_amount_render = 'NA';
            }
            else{
                cashback_render = 'Yes';
            }
            let max_cashback_render = value.max_cashback.slice(0, -1);
            //if(max_cashback_render == -1 || max_cashback_render == '-1'){
            if(max_cashback_render == '0.00'){
                max_cashback_render = 'NA';
            }
            return (
                <tr key={index + 1}>
                    <td>{value.scheme_name}</td>
                    <td>{value.bank_name}</td>
                    <td>{emi_typea}</td>
                    <td>{tenure_render}</td>
                    <td>{cashback_render}</td>
                    <td>{brand_sub_render}</td>
                    <td>{brand_sub_amount_render}</td>
                    <td>{max_cashback_render}</td>
                    <td>{timer3}</td>
                    <td>
                        <Switch className="react-switch"
                                height={20} width={38}
                                id={index + "_"}
                                onColor="#484b9a"
                                onChange={this.changeScheme.bind(this, value.id)}
                                checked={(this.state.scheme_master_list[value.id])? true : false}
                        />
                    </td>
                </tr>
            )
        });

        // let scheme_data_master = this.state.scheme_master_data.map((value, index) =>{
        //     let timer2 = new Date(value.record_update_timestamp)
        //     timer2.setHours( timer2.getHours() + 5 );
        //     timer2.setMinutes( timer2.getMinutes() + 30 );
        //     // timer
        //     let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
        //     return (
        //         <tr key={index + 1}>
        //             <td>{value.scheme_name}</td>
        //             <td>{value.bank_name}</td>
        //             <td>{timer3}</td>
        //         <td>
        //             <Switch className="react-switch"
        //                 height={20} width={38} 
        //                 id={index + "_"}
        //                 onColor="#484b9a"
        //                 onChange={this.changeScheme.bind(this, value.id)} 
        //                 checked={(this.state.scheme_master_list[value.id])? true : false}
        //             />
        //         </td>
        //     </tr>
        //     )
        // });


        let merchant_data_master = null;
        if(this.state.party_master_id != null && this.state.merchant2_display_data.length != 0)
        {
            merchant_data_master = this.state.merchant2_display_data.map((value, index) =>{
                // console.log(value.field_1);

                return (
                    <tr key={index + 1}>
                        <td>{value.merchant_id}</td>
                        <td>{value.merchant_name}</td>
                        <td>{value.merchant_code}</td>
                        <td>{value.chain_id}</td>
                        <td>{value.chain_name}</td>
                        <td>{value.chain_code}</td>
                        <td>{value.store_id}</td>
                        <td>{value.store_name}</td>
                        <td>{value.store_code}</td>
                        <td>{value.store_address}</td>
                        <td>{value.field_1}</td>
                        <td>
                            <Switch className="react-switch"
                                    height={20} width={38}
                                    id={index + "_"}
                                    onColor="#484b9a"
                                    onChange={this.changeMerchant.bind(this, value.id)}
                                    checked={(this.state.merchant_master_list[value.id])? true : false}
                            />
                        </td>
                    </tr>
                )

            });
        }

        let campaign_data = this.state.campaign_response.map((value,index) => {
            let timer = new Date(value.start_date).toJSON().slice(0, 19).replace('T', ' ');
            let timer1 = new Date(value.end_date).toJSON().slice(0, 19).replace('T', ' ');
            let timer2 = new Date(value.record_update_timestamp).toJSON().slice(0, 19).replace('T', ' ');
            return (
                <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td>{value.campaign_name}</td>
                    <td>{value.campaign_desc}</td>
                    <td>{timer}</td>
                    <td>{timer1}</td>
                    <td>{value.max_cashback}</td>
                    <td>{timer2}</td>
                    <td>
                        <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                        <Link className="viewButton" data-tip="View Promotion Summary"  to={"/admin/view-promotion2/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                    </td>
                </tr>
            )
        });

        //console.log(this.state.selectedMerchantSubvention);
        //console.log(this.state.sku_list);
        //console.log(this.state.selectedMerchValues);
        //console.log(this.state.state_ida.value);
        //console.log(this.state.city_ida.value);
        //console.log(this.state.merchant_ida.value);
        //console.log(this.state.chain_ida.value);
        //console.log(this.state.refinerMerch);
        // console.log(this.state.merchant_counter_array);
        // console.log(this.state.sku_list);
        // console.log(this.state.activer);
        // console.log(this.state.bankOptions);
        // console.log(this.state.bankOptionsValuer);


        //console.log(this.state.endDate);

        //const { redirect } = this.state;
        let bank_activer = this.state.activer;
        let start_date = (this.state.startDate); //.toDateString();
        let end_date = (this.state.endDate); //.toDateString();
        let max_txn = this.state.maxTxnAmount;


        let sku_selected = this.state.raw_display_data.map((value, index) => {
            let counter = 0;
            if ($.fn.DataTable.isDataTable('#sku_showTable3')) {
                $('#sku_showTable3').DataTable().destroy();
            }
            if (this.state.sku_list[value.sku] === true){
                counter = counter + 1;
                return (
                    <tr key={index + 1} className="trfont">
                        <td className="tdmodal">{counter}</td>
                        <td className="tdmodal">{value.brand}</td>
                        <td className="tdmodal">{value.category}</td>
                        <td className="tdmodal">{value.level_1}</td>
                        <td className="tdmodal">{value.level_2}</td>
                        <td className="tdmodal">{value.level_3}</td>
                        <td className="tdmodal">{value.level_4}</td>
                        <td className="tdmodal">{value.sku}</td>
                        <td className="tdmodal">{value.product_code}</td>
                        <td className="tdmodal">{value.mrp}</td>
                        <td className="tdmodal">{value.mop}</td>
                    </tr>
                );
            }
            $('#sku_showTable3').DataTable();
        });



        let merchant_selected = this.state.merchant3_data.map((value, index) => {
            let counter = 0;
            if ($.fn.DataTable.isDataTable('#merchant_showTable2')) {
                $('#merchant_showTable2').DataTable().destroy();
            }
            counter = counter + 1;
            return (
                <tr key={index + 1} className="trfont">
                    <td className="tdmodal">{index+1}</td>
                    <td className="tdmodal">{value.merchant_code}</td>
                    <td className="tdmodal">{value.chain_code}</td>
                    <td className="tdmodal">{value.store_code}</td>
                </tr>
            );

            $('#merchant_showTable2').DataTable();
        });

        let subvention_data = this.state.bank_name_list.map((value, index) => {
            let vala = '';
            if (this.state.brand_subvention_list[index] === 'Percent'){
                vala = this.state.maximum_cashback[index];
            }
            else{
                vala = 'NA';
            }
            if(bank_activer[index] === true)
            {
                if(this.state.isEMI[index] === true)
                {
                    return(
                        <tr key= {index + " " + this.state.bank_name_list[index]}>
                            <td className="tdmodal">{index+1}</td>
                            <td className="tdmodal">{this.state.bank_name_list[index]}</td>
                            <td className="tdmodal">Yes</td>
                            <td className="tdmodal">{this.state.zeroCost[index]? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M3']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M6']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M9']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M12']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M18']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M24']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.brand_subvention_list[index] + ": " + this.state.brand_subvention_value[index]}</td>
                            <td className="tdmodal">{vala}</td>
                        </tr>
                    );
                }
                else{
                    return(
                        <tr key= {index + " " + this.state.bank_name_list[index]}>
                            <td className="tdmodal">{index+1}</td>
                            <td className="tdmodal">{this.state.bank_name_list[index]}</td>
                            <td className="tdmodal">No</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">{this.state.brand_subvention_list[index] + ": " + this.state.brand_subvention_value[index]}</td>
                            <td className="tdmodal">{vala}</td>
                            {/* <td className="tdmodal">NA</td> */}
                        </tr>
                    );
                }
            }
            else{
                return(
                    <tr key= {index + " " + this.state.bank_name_list[index]}>
                        <td className="tdmodal">{index+1}</td>
                        <td className="tdmodal">{this.state.bank_name_list[index]}</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                    </tr>
                );
            }
        });

        let sku_show_data = this.state.raw_display_data.map((value,index) => {
            return (
                <tr key={index + 1}>
                    <td>{index+1}</td>
                    <td>{value.brand}</td>
                    <td>{value.category}</td>
                    <td>{value.model_name}</td>
                    <td>{value.model_number}</td>
                    <td>{value.model_description}</td>
                    <td>{value.sku}</td>
                    <td>{value.mrp}</td>
                    <td>{value.mop}</td>
                    <td>
                        <Switch className="react-switch"
                                height={20} width={38}
                                id={index + "_"}
                                onColor="#484b9a"
                                onChange={this.changeSKU.bind(this, value.sku)}
                                checked={(this.state.sku_list[value.sku])? true : false}
                        />
                    </td>
                </tr>
            );
        });

        //isDisabled={!(this.state.refinerMerch[2] && this.state.refineSearch)}
        //isDisabled={!(this.state.refinerMerch[3] && this.state.refineSearch)}
        //isDisabled={!(this.state.refinerMerch[4] && this.state.refineSearch)}
        // let refine_search = () => {
        //     return(
        //         <div className="row bottompaddingsubvention">
        //             <div className=" col-sm-6 col-md-3 col-xs-12">
        //                 <Label>Select Merchant</Label>
        //                 <Select name="refineValueMerchant"
        //                     // defaultValue={this.state.selectedMerchValues}
        //                     onChange={this.updateMerchRefineValues.bind(this, "Merchant_Level")}
        //                     options={this.state.brand_has_merchant}
        //                     placeholder="Select Merchant"
        //                     // isClearable={true}
        //                 />
        //             </div>
        //             <div className=" col-sm-6 col-md-3 col-xs-12">
        //                 <Label>Select Chain</Label>
        //                 <AsyncPaginate name="refineValueChain"
        //                     defaultValue={this.state.selectedMerchValues}
        //                     onChange={this.updateMerchRefineValues.bind(this, "Chain_Level")}
        //                     loadOptions={this._getRefineList.bind(this, "Chain_Level")}
        //                     additional={{
        //                         page: 1,
        //                     }}
        //                     placeholder="Select Chain"
        //                     isClearable={true}
        //                     isMulti={true}
        //                 />
        //             </div>
        //             <div className=" col-sm-6 col-md-3 col-xs-12">
        //                 <Label>Select Store</Label>
        //                 <AsyncPaginate name="refineValueStore"
        //                     defaultValue={this.state.selectedMerchValues}
        //                     onChange={this.updateMerchRefineValues.bind(this, "Store_Level")}
        //                     loadOptions={this._getRefineList.bind(this, "Store_Level")}
        //                     additional={{
        //                         page: 1,
        //                     }}
        //                     placeholder="Select Store"
        //                     isClearable={true}
        //                     isMulti={true}
        //                 />
        //             </div>
        //             <div className=" col-sm-6 col-md-3 col-xs-12">
        //                 <Button
        //                 color="primary"
        //                 disabled={this.state.follower}
        //                 onClick={this.evalMerchantCounter.bind(this)}> Add Merchant</Button>{' '}
        //             </div>
        //         </div>
        //     );
        // }



        let refine_disabler = false;
        if (this.state.selectedMerchantSubvention == "All_Level" || this.state.selectedMerchantSubvention == "State_Level"){
            refine_disabler = true;
        }
        else{
            refine_disabler = false;
        }

        let selected_merch_refine1 = () => {
            if (this.state.refineSearch == true){
                return this.state.selectedRefineSubvention;
            }
            else{
                return this.state.selectedMerchantSubvention;
            }
        }

        let selected_merch_refine = () => {
            if (this.state.refineSearch == true){
                return this.state.merchant_ida.label;
            }
            else{
                return this.state.selectedMerchValues[0];
            }
        }
        let variabler = this.state.current_tab;
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
                margin: "0px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px",
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px",
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "15px",
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px',
            }),
            menu: styles => ({ ...styles, zIndex: 999})
        };


        let merchant_displayer = () => {
            if(decoded.userGroup == 2 || decoded.userGroup == '2'){
                return(<div></div>)
            }
            else{
                return(
                    <div className="row">
                        <div className="col-md-4">
                            <Label>Select Merchant:</Label>
                            <ReactMultiSelectCheckboxes name={"merchant_selector"}
                                                        components={{ MenuList }}
                                                        isClearable={false}
                                                        onChange={this.changeMerchant1.bind(this)}
                                                        styles={customStyles} className="report-listbox"
                                                        options={this.state.merchantList}
                                                        value={this.state.merchantValue}
                                                        isMulti
                                                        placeholderButtonLabel="All"
                            />
                        </div>
                        <div className="col-md-4">
                            <Label>Select Chain:</Label>
                            <ReactMultiSelectCheckboxes name={"chain_selector"}
                                                        components={{ MenuList }}
                                                        isClearable={false}
                                                        onChange={this.changeChain.bind(this)}
                                                        styles={customStyles} className="report-listbox"
                                                        options={this.state.chainList}
                                                        value={this.state.chainValue}
                                                        isMulti
                                                        placeholderButtonLabel="All"
                            />
                        </div>
                        <div className="col-md-4">
                            <Label>Select Store:</Label>
                            <ReactMultiSelectCheckboxes name={"store_selector"}
                                                        components={{ MenuList }}
                                                        isClearable={false}
                                                        onChange={this.changeStore.bind(this)}
                                                        styles={customStyles} className="report-listbox"
                                                        options={this.state.storeList}
                                                        value={this.state.storeValue}
                                                        isMulti
                                                        placeholderButtonLabel="All"
                            />
                        </div>
                    </div>
                )
            }
        }

        let merchant_maintainer_data = this.state.merchant2_display_data.map((value, index) =>{
            return (
                <tr key={index + 1}>
                    <td>{index+1}</td>
                    <td>{value.merchant_id}</td>
                    <td>{value.merchant_name}</td>
                    <td>{value.merchant_code}</td>
                    <td>{value.chain_id}</td>
                    <td>{value.chain_name}</td>
                    <td>{value.chain_code}</td>
                    <td>{value.store_id}</td>
                    <td>{value.store_name}</td>
                    <td>{value.store_code}</td>
                    <td>{value.store_address}</td>
                </tr>
            )
        });



        return(
            <div className="content">
                <CommonNavbar/>
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 top-pad-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">Create Promotion</h4>
                                </div>
                                <div className="content">
                                    {/* defaultTab="vertical-tab-two" */}
                                    <div className='sweet-loading'>
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={20}
                                            color={'#123abc'}
                                            loading={this.state.loading}
                                        />
                                    </div>
                                    <Tabs defaultTab={variabler} vertical className="vertical-tabs">
                                        <TabList>
                                            <Tab className="tab-title" tabFor="vertical-tab-one" onClick={this.tabClicker.bind(this, 1)}>
                                                <h4 className='title'>Products</h4>
                                                <span className='text-muted'>
                                                    Select products
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-two" onClick={this.tabClicker.bind(this, 2)} disabled={this.state.stepper[1]}>
                                                <h4 className='title'> Schemes</h4>
                                                <span className='text-muted'>
                                                    Select schemes
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-three" onClick={this.tabClicker.bind(this, 3)} disabled={this.state.stepper[2]}>
                                                <h4 className='title'>  Merchants</h4>
                                                <span className='text-muted'>
                                                    Select merchants
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-four" onClick={this.tabClicker.bind(this, 4)} disabled={this.state.stepper[3]}>
                                                <h4 className='title'>  Details</h4>
                                                <span className='text-muted'>
                                                    Add details
                                                </span>
                                            </Tab>
                                        </TabList>
                                        <TabPanel tabId="vertical-tab-one">
                                            {/* <Collapse isOpen={this.state.mapField0}>     */}
                                            <div className="card-query-builder" >

                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef2}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Products</h4>
                                                            <span className='text-muted'>Please select products/SKUs from the below given list</span>
                                                        </div>

                                                        <Modal className="modalsmall" isOpen={this.state.newConfirmationModel}
                                                               toggle={this.toggleConfirmationModel.bind(this)}
                                                               size="sm"
                                                        >
                                                            <ModalBody className="smallcontent">
                                                                <div className="row">
                                                                    <div className="col-xs-12 ">
                                                                        <h4 className="modalh4">Are you sure you want to save?</h4>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="modalrow">
                                                                        Duration:
                                                                    <div className="row">
                                                                        <div className="col-xs-12 col-sm-6 col-md-2">
                                                                            <Label>Start Date: </Label>
                                                                        </div>
                                                                        <div className="col-xs-12 col-sm-6 col-md-2">
                                                                            <Label>{start_date}</Label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                    <div className="col-xs-12 col-sm-6 col-md-2">
                                                                            <Label>End Date: </Label>
                                                                        </div>
                                                                        <div className="col-xs-12 col-sm-6 col-md-2">
                                                                            <Label>{end_date}</Label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <hr/>
                                                                <div className="row">
                                                                    <div className="col-xs-12 col-sm-6">
                                                                        Maximum cashback allowed per card:  Rs.{max_txn}
                                                                    </div>
                                                                </div>
                                                                <hr/>
                                                                {/*merch_selected_details()
                                                                <div className="modalrow">
                                                                    <h5 className="title">Your selected product list</h5>
                                                                    <div className="modalrow">
                                                                        <div className="content table-responsive">
                                                                            <table className="table table-striped table-hover" id="sku_showTable3" >
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Sr No.</th>
                                                                                        <th>Brand</th>
                                                                                        <th>Category</th>
                                                                                        <th>Level 1</th>
                                                                                        <th>Level 2</th>
                                                                                        <th>Level 3</th>
                                                                                        <th>Level 4</th>
                                                                                        <th>SKU</th>
                                                                                        <th>Product Code</th>
                                                                                        <th>MRP</th>
                                                                                        <th>MOP</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {sku_selected}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="modalrow">
                                                                    <h5 className="title">Your selected scheme list</h5>
                                                                    <div className="modalrow">
                                                                        <div className="content table-responsive">
                                                                            <table className="table table-striped table-hover" id="subvention_showTable2">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Sr No.</th>
                                                                                        <th>Scheme Name</th>
                                                                                        <th>Bank Name</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {subvention_selected}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <hr/>
                                                                <div className="modalrow">
                                                                    <h5 className="title">Your selected merchant list</h5>
                                                                    <div className="modalrow">
                                                                        <div className="content table-responsive">
                                                                            <table className="table table-striped table-hover" id="merchant_showTable2">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Sr No.</th>
                                                                                        <th>Merchant Code</th>
                                                                                        <th>Chain Code</th>
                                                                                        <th>Store Code</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {merchant_selected}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <hr/> */}
                                                            </ModalBody>
                                                            <ModalFooter>
                                                                <Button color="primary" className="btn-capitalize btnmodal" onClick={this.sendCompleteScheme}>Yes</Button>{' '}
                                                                <Button color="secondary" className="btn-capitalize2 btnmodal" onClick={this.toggleConfirmationModel.bind(this)}>No</Button>
                                                            </ModalFooter>
                                                        </Modal>
                                                        <div className="col-md-12">
                                                            <div className="pull-right">
                                                                <a href="#"  onClick={this.selectAll.bind(this)}>Select all</a>{ '      ' }&nbsp;&nbsp;&nbsp;
                                                                <a href="#"  onClick={this.deSelectAll.bind(this)}>Clear</a>{ '  ' }
                                                            </div>

                                                            {/* <Button color="primary" className="pull-right btn-capitalize" onClick={this.selectAll.bind(this)}> Select All</Button>{' '}
                                                            <Button color="primary" className="pull-right btn-capitalize" onClick={this.deSelectAll.bind(this)}> Deselect All</Button>{' '} */}
                                                        </div>

                                                        <div className="table-full-width table-responsive">
                                                            <div className="row m-0">
                                                                <div className="col-md-12">
                                                                    <table className="table table-striped table-hover" id="sku_showTable">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Sr No.</th>
                                                                            <th>Brand</th>
                                                                            <th>Category</th>
                                                                            <th>Model Name</th>
                                                                            <th>Model Number</th>
                                                                            <th>Model Description</th>
                                                                            <th>SKU</th>
                                                                            <th>MRP</th>
                                                                            <th>MOP</th>
                                                                            <th>Applicable?</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {sku_show_data}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <button onClick={this.openSectionToBanks.bind(this, true)} className="btn btn-primary pull-right btn-capitalize">Choose Schemes</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* </Collapse> */}
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-two">
                                            <div className="card-query-builder" >
                                                {/* <NotificationSystem ref="notificationSystem" style={style} />
                                                <ReactTooltip /> */}
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef2}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Schemes</h4>
                                                            <span className="text-muted">Please select schemes from below list</span>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="pull-right">
                                                                <a href="#"  onClick={this.selectAllPromotions.bind(this)}>Select all</a>{ '      ' }&nbsp;&nbsp;&nbsp;
                                                                <a href="#"  onClick={this.deselectAllPromotions.bind(this)}>Clear</a>{ '  ' }
                                                            </div>
                                                        </div>
                                                        <div className="table-full-width table-responsive">
                                                            <table className="table table-striped table-hover" id="brandSchemeMasterViewTable">
                                                                <thead>
                                                                <tr>
                                                                    <th>Scheme Name</th>
                                                                    <th>Bank Name</th>
                                                                    <th>Is Zero Cost EMI?</th>
                                                                    <th>Tenure</th>
                                                                    <th>Avail Cashback?</th>
                                                                    <th>Brand Sub</th>
                                                                    <th>Brand Sub Amount</th>
                                                                    <th>Max Cash back</th>
                                                                    <th>Time stamp</th>
                                                                    <th>Select Scheme</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {scheme_data_master}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="row">
                                                            <div className ="col-md-12">
                                                                <button onClick={this.sendEMIMappings.bind(this, true)} className="btn btn-primary pull-right btn-capitalize">Choose Merchants</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="header">
                                                            <h4 className="title">Upload Scheme Mapping</h4>
                                                        </div>
                                                        <hr/>
                                                        <div className="content">
                                                            <form method="post" action="#" id="#">
                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <div className="form-group">
                                                                            <label htmlFor="queryName" className="">Upload Your CSV File</label>
                                                                            <input type="file" name="file" className="form-control" onChange={this.onChangeHandlerScheme} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                            <div className="row">
                                                                            <label htmlFor="sampleName">Sample File</label>
                                                                            </div>
                                                                            <div className="row">
                                                                                <Button color="primary" name="download" className="btn-capitalize" onClick={this.downloadCSV.bind(this, 'the_sample_template.csv')}>Download Sample File</Button>
                                                                            </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="row">
                                                                            <label htmlFor="sampleName">CSV Rules</label>
                                                                        </div>
                                                                        <div className="row">
                                                                        <Card>
                                                                            <CardBody>
                                                                            <CardText>
                                                                                Lorem Ipsum
                                                                            </CardText>
                                                                            </CardBody>
                                                                        </Card>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <button type="button" className="btn btn-primary btn-capitalize" onClick={this.fileUploadHandlerScheme.bind(this)} disabled={this.state.isSubmit}>Upload File</button>
                                                                    </div>
                                                                    <div className='sweet-loading'>
                                                                        <BeatLoader
                                                                            css={override}
                                                                            sizeUnit={"px"}
                                                                            size={20}
                                                                            color={'#123abc'}
                                                                            loading={this.state.loading}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="clearfix"></div>
                                                            </form>
                                                            <div className="footer">
                                                                <div className="stats"><i></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            {/* <div className="content">
                                                            <div className="col-md-12">
                                                                <Button color="primary" className="pull-right" onClick={this.selectAllBanks.bind(this)}> Select All</Button>{' '}
                                                                <Button color="primary" className="pull-right" onClick={this.deSelectAllBanks.bind(this)}> Deselect All</Button>{' '}
                                                            </div>
                                                            <div className="rowbanks">
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="0" label="AMEX" onChange={this.changeActiver.bind(this, 0)} checked={!!(this.state.activer[0])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="1" label="Axis Bank" onChange={this.changeActiver.bind(this, 1)} checked={!!(this.state.activer[1])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="2" label="Citi Bank" onChange={this.changeActiver.bind(this, 2)} checked={!!(this.state.activer[2])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="3" label="HDFC Bank" onChange={this.changeActiver.bind(this, 3)} checked={!!(this.state.activer[3])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="4" label="HSBC Bank" onChange={this.changeActiver.bind(this, 4)} checked={!!(this.state.activer[4])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="5" label="ICICI Bank" onChange={this.changeActiver.bind(this, 5)} checked={!!(this.state.activer[5])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="6" label="IndusInd Bank" onChange={this.changeActiver.bind(this, 6)} checked={!!(this.state.activer[6])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="7" label="Kotak Bank" onChange={this.changeActiver.bind(this, 7)} checked={!!(this.state.activer[7])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="8" label="RBL" onChange={this.changeActiver.bind(this, 8)} checked={!!(this.state.activer[8])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="9" label="SBI" onChange={this.changeActiver.bind(this, 9)} checked={!!(this.state.activer[9])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="10" label="Standard Chartered" onChange={this.changeActiver.bind(this, 10)} checked={!!(this.state.activer[10])} />
                                                                </div>
                                                                <div className="col-md-3 col-sm-6 col-xs-12">
                                                                    <Checkbox  number="11" label="Yes Bank" onChange={this.changeActiver.bind(this, 11)} checked={!!(this.state.activer[11])} />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <button onClick={this.sendBankMappings.bind(this, true)} className="btn btn-primary pull-right">Continue</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <Collapse isOpen={this.state.mapField}>
                                                <div className="card-query-builder subvention-brand ">
                                                    <div className="col-md-12 pt-5">
                                                        <div className="card " ref={this.myRef}>
                                                            <div className="header">
                                                                <h4 className="title">Choose Offers</h4>
                                                            </div>
                                                            <hr/>
                                                            <div className= "content">
                                                                <div className="mapField" >
                                                                    <div className="row bottompaddingsubvention">
                                                                    /* {emi_displayer}
                                                                    {bank_names}
                                                                    </div>
                                                                    <hr/>
                                                                    <div className="row bottompaddingsubvention">
                                                                        <div className="col-md-12">
                                                                            <button onClick={this.sendEMIMappings.bind(this, true)} className="btn btn-primary buttonpaddingsubvention pull-right">Choose Merchants</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Collapse> */}
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-three">
                                            <div className="col-md-12">

                                                <div className="card noshadow">

                                                    <div className="row">

                                                        <div className="col-md-12">
                                                            <div className="header header-promotion">
                                                                <h4 className="title">Merchants</h4>
                                                                <span className="text-muted">Please select merchants from below list</span>
                                                            </div>
                                                            {merchant_displayer()}
                                                            <div className="row top-margin-10">
                                                                <div className ="col-md-12">
                                                                    <button onClick={this.merchantSubmitHandler.bind(this)} className="btn btn-primary pull-right btn-capitalize">Continue</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="footer">
                                                        <div className="stats"><i></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-four">
                                            <div className="card-query-builder subvention-brand ">
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Promotion Details</h4>
                                                            <span className="text-muted">Please provide the following promotion details </span>
                                                        </div>

                                                        <div className= "content">
                                                            <div className="row bottompaddingsubvention">
                                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Promotion Name</Label>
                                                                    <Input id="campaign_name" className="maxheighter" value={this.state.campaign_name} onChange={(e)=> {
                                                                        let {campaign_name} = this.state;
                                                                        campaign_name = e.target.value;
                                                                        if((e.target.value === '')){
                                                                            this.handleNotificationClick("tr", 3, "Insert promotion name");
                                                                        }
                                                                        this.setState({
                                                                            campaign_name: campaign_name,
                                                                            mapField2: false
                                                                        })
                                                                    }}/>
                                                                </div>
                                                                <div className=" col-sm-12 col-md-6 col-xs-12">
                                                                    <Label>Promotion Description</Label>
                                                                    <Input id="campaign_desc" className="maxheighter" value={this.state.campaign_ndesc} onChange={(e)=> {
                                                                        let {campaign_desc} = this.state;
                                                                        campaign_desc = e.target.value;
                                                                        if((e.target.value === '')){
                                                                            this.handleNotificationClick("tr", 3, "Insert promotion description");
                                                                        }
                                                                        this.setState({
                                                                            campaign_desc: campaign_desc,
                                                                            mapField2: false
                                                                        })
                                                                    }}/>
                                                                </div>
                                                            </div>

                                                            <div className="row bottompaddingsubvention">
                                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Select start date</Label>
                                                                    <DatePicker
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={Date.parse(this.state.startDate)}
                                                                        onChange={this.handleFromChange}
                                                                        minDate={new Date()}
                                                                    />
                                                                </div>
                                                                <div className="col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Select end date</Label>
                                                                    <DatePicker
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={Date.parse(this.state.endDate)}
                                                                        onChange={this.handleToChange}
                                                                        minDate={new Date()}
                                                                    />
                                                                </div>
                                                                {/* <div className="col-sm-6 col-md-4    col-xs-12">
                                                                <Label>Maximum cashback allowed per card</Label>
                                                                <Input id="txn_value" className="maxheighter" value={this.state.maxTxnAmount} onChange={(e)=> {
                                                                    let {maxTxnAmount1} = this.state;
                                                                    maxTxnAmount1 = e.target.value;
                                                                    if(((e.target.value)*1) <= 0 || (e.target.value === '')){
                                                                        this.handleNotificationClick("tr", 3, "Insert value greater than 0");
                                                                    }
                                                                    this.setState({
                                                                        maxTxnAmount: maxTxnAmount1,
                                                                        mapField2: false
                                                                    })
                                                                }}/>
                                                                </div> */}
                                                            </div>
                                                            <br/>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <button onClick={this.openSectionToProduct.bind(this, true)} className="btn btn-primary pull-right btn-capitalize">Create Promotion</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
// const rootElement = document.getElementById("root");
// ReactDOM.render(<App/>, rootElement);
}
export default NewCreatePromotion;